import { render, staticRenderFns } from "./80.vue?vue&type=template&id=2a155d4a&scoped=true&"
var script = {}
import style0 from "./80.vue?vue&type=style&index=0&id=2a155d4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a155d4a",
  null
  
)

export default component.exports